module.exports = __webpack_public_path__ + "static/media/sofi-chart-on-tv.3b56ff25.png";